import React from 'react'
import styles from './progressbar.module.scss'

function ProgressBar({ totalSteps, currentStep }) {

  return (
    <div className={styles.progress}>
      {Array.from({ length: totalSteps }, (_, index) => <div key={index} className={
        index + 1 < currentStep ? styles.progress__step_done : styles.progress__step
      }></div>)}
		</div>
  )
}

export  { ProgressBar }
